export default __webpack_public_path__ + "static/media/pencil.291e1ead.svg";